import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Model } from 'src/app/shared/models/clux/model-legacy';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-delete-confirmation',
  templateUrl: './delete-confirmation.component.html',
  styleUrls: ['./delete-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButton],
})
export class DeleteConfirmationComponent {
  private dialogRef = inject<MatDialogRef<DeleteConfirmationComponent>>(MatDialogRef);
  public data = inject<Model.DialogData>(MAT_DIALOG_DATA);

  /**
   * This method is used to confirm the operation to delete.
   */
  public confirmAction(isAction: boolean): void {
    this.dialogRef.close(isAction);
  }
}
